export default "__VITE_ASSET__BeoWZ0QX__"